export const types = {
  GET: 'GET_APPS',
};

export const appsReducer = (state = [], action) => {
  switch (action.type) {
    case types.GET:
      return action.payload;
    default:
      return state;
  }
};
